import { Card, Divider, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { GeneralTable } from 'src/components/general';
import { GAME_PALYLIST_MODAL_TABLE_HEAD } from 'src/constants/tableHeads';
import useTable from 'src/hooks/useTable';
import { useFetchGameJoinPlaylistList } from 'src/network/gameJoin';
import GamePlaylistTableRow from './GamePlaylistTableRow';
import GamePlaylistTableToolbar from './GamePlaylistTableToolbar';

// ----------------------------------------------------------------------

export default function GamePlaylistTableModal({ selectContentHandler }) {
  const useTableOptions = useTable();
  const { page, onChangePage } = useTableOptions;

  const [tableData, setTableData] = useState([]);

  const [filterItems, setFilterItems] = useState({
    AppID: -1,
    Title: '',
  });

  // ----------------------------------------------------------------------

  const { isLoading, data } = useFetchGameJoinPlaylistList(filterItems, page);

  useEffect(() => {
    if (data) {
      const result = data?.data?.items || [];
      setTableData([...result]);
    }
  }, [data, page, filterItems]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 3, overflow: 'visible' }}>
          <GamePlaylistTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} />

          <Divider sx={{ my: 2 }} />

          <GeneralTable
            tableContainerSX={{ position: 'relative' }}
            rowID="GameJoinApplicationPlayListID"
            tableData={tableData}
            headLabel={GAME_PALYLIST_MODAL_TABLE_HEAD}
            CustomTableRow={GamePlaylistTableRow}
            useTableOptions={useTableOptions}
            hasDeleteOption={false}
            selectContentHandler={selectContentHandler}
            isLoading={isLoading}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
